import { render, staticRenderFns } from "./InvitacionesAbonados.vue?vue&type=template&id=88c41e54"
import script from "./InvitacionesAbonados.vue?vue&type=script&setup=true&lang=js"
export * from "./InvitacionesAbonados.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports